import { Box } from "@stenajs-webui/core";
import {
  Banner,
  stenaAnimals,
  stenaBusinessCard,
  stenaPlugin,
} from "@stenajs-webui/elements";
import type { FC } from "react";

import { GoodsDescriptionsEnsHintBanner } from "../../../../common-ui/goods/GoodsDescriptionsEnsHintBanner";
import {
  InformationMessageType,
  resolveInformationMessageBannerVariant,
} from "../../../../common-ui/information-message/informationMessageUtils";
import type { DetailedBooking_autoCancellation } from "../../../../common/graphql/fragments/gql/DetailedBooking";
import { Information } from "../../../../common/texts";
import type { ApprovalConfig } from "../../../../common/utils/approvalInfo";
import { AutoCancellationInfoBanner } from "./AutoCancellationInfoBanner";
import { BookingHazardousGoodsBanner } from "./BookingHazardousGoodsBanner";

interface BookingDetailsViewBannersProps {
  arrivalNotepadInfo: ApprovalConfig | null;
  autoCancellation: DetailedBooking_autoCancellation | null;
  bookingNo: number;
  hazardousGoodsApprovalInfo: ApprovalConfig | null;
  hazardousGoodsApproved: boolean;
  livestockInfoText: string | undefined;
  loadingPreferenceApprovalInfo: ApprovalConfig | null;
  showEnsGoodsBanner: boolean;
  showHazGoodsPaymentInformation: boolean;
  showPluginInformation: boolean;
}

export const BookingDetailsViewBanners: FC<BookingDetailsViewBannersProps> = ({
  arrivalNotepadInfo,
  bookingNo,
  hazardousGoodsApprovalInfo,
  hazardousGoodsApproved,
  loadingPreferenceApprovalInfo,
  livestockInfoText,
  showHazGoodsPaymentInformation,
  autoCancellation,
  showPluginInformation,
  showEnsGoodsBanner,
}) => {
  return (
    <Box spacing gap>
      {autoCancellation && (
        <AutoCancellationInfoBanner info={autoCancellation} />
      )}
      {hazardousGoodsApprovalInfo && (
        <BookingHazardousGoodsBanner
          approvalInfo={hazardousGoodsApprovalInfo}
          bookingNo={bookingNo}
          hazardousGoodsApproved={hazardousGoodsApproved}
        />
      )}

      {showHazGoodsPaymentInformation && (
        <Banner
          icon={stenaBusinessCard}
          variant={"info"}
          text={Information.HazardousGoodsConfirmedPayableOnline}
        />
      )}

      {loadingPreferenceApprovalInfo && (
        <Banner
          variant={resolveInformationMessageBannerVariant(
            loadingPreferenceApprovalInfo.type,
          )}
          text={loadingPreferenceApprovalInfo.descriptionText}
        />
      )}

      {arrivalNotepadInfo && (
        <Banner
          variant={resolveInformationMessageBannerVariant(
            arrivalNotepadInfo.type,
          )}
          text={arrivalNotepadInfo.descriptionText}
        />
      )}

      {livestockInfoText && (
        <Banner
          icon={stenaAnimals}
          variant={resolveInformationMessageBannerVariant(
            InformationMessageType.SoftWarning,
          )}
          text={livestockInfoText}
        />
      )}

      {showPluginInformation && (
        <Banner icon={stenaPlugin} variant={"info"} text={Information.Plugin} />
      )}

      {showEnsGoodsBanner && <GoodsDescriptionsEnsHintBanner />}
    </Box>
  );
};
